/* eslint-disable no-unused-vars */
import { putObraSocial, getTurnsByDateProfessionalLibre, getTurnsByDateProfessional } from '../services/data.service';

export const tableColumns = [
    { field: 'descripcion', headerName: 'Descripcion', editable: true },
    {
        field: 'activa',
        headerName: 'Activa',
        options: {
            type: 'checkbox',
            onChange: handleCheckboxChange
        },
        flex: 0.3
    },
    { field: 'orden', headerName: 'Orden', editable: true, flex: 0.3 },
    { field: 'maxAnual', headerName: 'Maximo Anual', editable: true, flex: 0.3 },
    { field: 'maxMensual', headerName: 'Maximo Mensual', editable: true, flex: 0.3 },
    { field: 'vigencia', headerName: 'Vigencia', editable: true, flex: 0.3 },
    { field: 'mensaje1', headerName: 'Mensaje', editable: true }
];

export async function handleCheckboxChange (event, name, row) {
    const response = await putObraSocial(row.id, { [name]: event.target.checked });
    try {
        console.log(response);
    } catch (err) {
        console.error(err);
        return [];
    }
}
